<!--
 This is the billing page, it uses the dashboard layout in:
 "./layouts/Dashboard.vue" .
 -->

<template>
    <div>

        <a-row type="flex" :gutter="24">

            <!-- Billing Info Column -->
            <a-col :span="24" :md="16">
                <a-row type="flex" :gutter="24">
                    <a-col :span="24" :xl="12" class="mb-24">

                        <!-- Master Card -->
                        <a-card class="card-credit header-solid h-full" style="background: rgb(221,31,16);
background: linear-gradient(45deg, rgba(221,31,16,1) 46%, rgba(252,247,247,1) 79%, rgba(255,19,0,1) 100%);">
                            <template #title>
                                <p class="text-dark"> آسان تهاتر ایرانیان </p>


                            </template>
                            <h5 class="card-number text-dark">{{ info . cart_number }} </h5>

                            <div class="card-footer">
                                <div class="mr-30">
                                    <p class="text-dark">دارنده کارت</p>
                                    <h6 class="text-dark"> {{info ?  $root.full_name(info.firstname , info.lastname) : '' }} </h6>
                                </div>

                                <div class="card-footer-col col-logo ml-auto">
                                    <img src="../../../public/images/logos/mastercard-logo.png">
                                </div>
                            </div>
                        </a-card>
                        <!-- / Master Card -->

                    </a-col>
                    <!--  Salary Card -->

                    <a-col :span="12" :xl="6" class="mb-24"
                        v-for="(salary, index) in salaries" :key="index">
                        <a-card :bordered="false" class="widget-2 h-full">
                            <a-statistic :value="salary.value" :prefix="salary.prefix">
                                <template #title>
                                    <div class="icon" v-html="salary.icon"></div>
                                    <h6>{{ salary . title }}</h6>
                                    <p>{{ salary . content }}</p>
                                </template>
                            </a-statistic>
                        </a-card>
                    </a-col>



                    <a-col :span="24" class="mb-24">

                        <!-- Payment Methods Card -->
                        <a-card :bordered="false" class="header-solid h-full" :bodyStyle="{ paddingTop: 0, }">
                            <template #title>
                                <a-row type="flex" align="middle">
                                    <a-col :span="24" :md="12">
                                        <h6 class="font-semibold m-0"> حساب های کاربر</h6>
                                    </a-col>
                                   
                                </a-row>
                            </template>
                            <a-row :gutter="[24, 24]" style="margin-top: 1%;">
                                <a-col :span="24" :md="12">
                                    <a-card class="payment-method-card">
                                        <img src="images/logos/mastercard-logo.png" alt="">
                                     <b-badge variant="light" class="text-dark">شماره کارت</b-badge>
                                        <h6 class="card-number">   {{info.card_number}}   </h6>
                                       
                                    </a-card>
                                </a-col>
                                <a-col :span="24" :md="12">
                                    <a-card class="payment-method-card">
                                        <img src="images/logos/visa-logo.png" alt="">
                                         <b-badge variant="light" class="text-dark">شبا</b-badge>
                                        <h6 class="card-number">  {{info.shaba}}</h6>
                                       
                                    </a-card>
                                </a-col>
                            </a-row>
                        </a-card>
                        <!-- Payment Methods Card -->

                    </a-col>
                </a-row>
            </a-col>
            <!-- / Billing Info Column -->

            <!-- Invoices Column -->
            <a-col :span="24" :md="8" class="mb-24">
                <!-- Invoices Card -->
                <a-card :bordered="false" class="header-solid h-full"
                    :bodyStyle="{ paddingTop: 0, paddingBottom: '16px' }">
                    <template #title>
                        <h6 class="font-semibold m-0"> سود های واریز شده</h6>
                    </template>
                    <template slot="extra" class="mb-0">
                        <span>{{ $root . number_format(sumProfits) }}</span> :
                        مجموع

                    </template>

                    <a-list class="invoice-list" item-layout="horizontal" :split="false"
                        :data-source="profits">
                        <a-list-item slot="renderItem" slot-scope="item">
                            <a-list-item-meta :title="new Date(item.created_at).toLocaleDateString('fa-IR')"
                                :description="item.description"></a-list-item-meta>
                            <div class="amount"> {{ $root.number_format(item . amount) }}</div>
                        </a-list-item>
                    </a-list>
                    <a-row class="pagination">
                        <a-pagination :total="total" :item-render="$root.itemRender"
                            @change="getProfits(current_page)" v-model="current_page" />
                    </a-row>
                </a-card>
                <!-- / Invoices Card -->

            </a-col>
            <!-- / Invoices Column -->

        </a-row>

        <a-row type="flex" :gutter="24">

            <!-- Billing Information Column -->
            <a-col :span="24" :md="16" class="mb-24">

                <!-- Billing Information Card -->
                <a-card :bordered="false" class="header-solid h-full"
                    :bodyStyle="{ paddingTop: 0, paddingBottom: '16px' }">
					<template #title>
                        <h6 class="font-semibold m-0"> سفارشات کاربر   </h6>
                    </template>
                    <div >
                        <section class="w-100 p-4 text-center">
                            <table class="table table-hover">
                                <thead>
                                    <tr>
                                        <th scope="col">شناسه</th>
                                        <th scope="col">خریدار</th>
                                        <th scope="col"> قیمت نقدی</th>
                                        <th scope="col"> قیمت تهاتری</th>
                                        <th scope="col"> شماره پیگیری</th>
                                        <th scope="col">  تاریخ پرداخت</th>
                                        <th scope="col">   وضعیت سفارش</th>

                                        <th scope="col"> مشاهده</th>

                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="row in data">
                                       <th scope="row">#{{ row . id }}</th>
									    
                                        <td>

                                            <b-badge variant="light" class="text-dark">
                                                {{ info.firstname + ' ' + info . lastname }}</b-badge>
                                        </td>
										
                                        <td>
                                            <b-badge variant="light" class="bg-secondary">
                                                {{ $root . number_format(row . total) }}</b-badge>


                                        </td>

                                        <td>
                                            <b-badge variant="light" class="bg-secondary">
                                                {{ $root . number_format(row . barter) }}
                                              </b-badge>
                                        </td>

                                        <td>
                                            <b-badge variant="light" class="bg-success">{{ row . tracking_code }}</b-badge>
                                        </td>
                                        <td>
                                            <b-badge variant="light" class="text-dark">{{row . paid_date != null ? new Date(row . paid_date).toLocaleDateString('fa-IR') : '-' }}</b-badge>
                                        </td>
										

                                        <td>
                                            <b-badge variant="light" class="bg-muted">{{ row . status.title }}</b-badge>
                                        </td>
										
                                        <td>
                                            <a-button class="btn-outline-info" shape="square" icon="eye" :href="'/orders/detail/'+row.id" />
                                            &nbsp;
                                        </td> 
                                    </tr>
                                </tbody>
                            </table>
                        </section>
                        <a-row class="pagination">
                            <a-pagination :total="total3" :item-render="$root.itemRender"
                                @change="getOrders(current_page3)" v-model="current_page3" />
                        </a-row>
                    </div>
                </a-card>
                <!-- / Billing Information Card -->

            </a-col>
            <!-- Billing Information Column -->

            <!-- Your Transactions Column -->
            <a-col :span="24" :md="8" class="mb-24">

                <!-- Your Transactions Card -->
                <a-card :bordered="false" class="header-solid h-full"
                    :bodyStyle="{ paddingTop: 0, paddingBottom: '16px' }">
                    <template #title>
                        <h6 class="font-semibold m-0"> مبادلات کاربر </h6>
                    </template>
                    <p slot="extra" class="card-header-date">
                        <svg width="18" height="18" viewBox="0 0 20 20" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <path class="fill-muted" fill-rule="evenodd" clip-rule="evenodd"
                                d="M6 2C5.44772 2 5 2.44772 5 3V4H4C2.89543 4 2 4.89543 2 6V16C2 17.1046 2.89543 18 4 18H16C17.1046 18 18 17.1046 18 16V6C18 4.89543 17.1046 4 16 4H15V3C15 2.44772 14.5523 2 14 2C13.4477 2 13 2.44772 13 3V4H7V3C7 2.44772 6.55228 2 6 2ZM6 7C5.44772 7 5 7.44772 5 8C5 8.55228 5.44772 9 6 9H14C14.5523 9 15 8.55228 15 8C15 7.44772 14.5523 7 14 7H6Z"
                                fill="#111827" />
                        </svg>
                        <span>از {{ new Date(info.created_at).toLocaleDateString('fa-IR') }}   </span>
                    </p>
                    <a-list class="transactions-list" item-layout="horizontal" :split="false"
                        :data-source="transactions">
                        <a-list-item slot="renderItem" slot-scope="item">
                            <template >
                                <a-list-item-meta :title="item.description" :description="new Date(item.created_at).toLocaleDateString('fa-IR')">
                                    <a-avatar size="small" v-if="item.type == 'in'" slot="avatar"
                                        style="background-color: #EDF9E7">
                                        <svg width="10" height="10" viewBox="0 0 20 20" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path class="fill-success" fill-rule="evenodd" clip-rule="evenodd"
                                                d="M10 3C10.5523 3 11 3.44772 11 4V9H16C16.5523 9 17 9.44772 17 10C17 10.5523 16.5523 11 16 11H11V16C11 16.5523 10.5523 17 10 17C9.44772 17 9 16.5523 9 16V11H4C3.44772 11 3 10.5523 3 10C3 9.44771 3.44772 9 4 9L9 9V4C9 3.44772 9.44772 3 10 3Z" />
                                        </svg>
                                    </a-avatar>
                                   
                                    <a-avatar size="small" v-else slot="avatar"
                                        style="background-color: #FEE9EA">
                                        <svg width="10" height="10" viewBox="0 0 20 20" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path class="fill-danger" fill-rule="evenodd" clip-rule="evenodd"
                                                d="M5 10C5 9.44772 5.44772 9 6 9L14 9C14.5523 9 15 9.44772 15 10C15 10.5523 14.5523 11 14 11L6 11C5.44772 11 5 10.5523 5 10Z" />
                                        </svg>
                                    </a-avatar>
                                </a-list-item-meta>
                                <div class="amount">
                                    <span v-if="item.type == 'in'" class="text-success">
                                        {{ $root.number_format(item . amount) }} 
                                    </span>
                                   
                                    <span v-else class="text-danger">
                                        {{ $root.number_format(item . amount) }} 
                                    </span>
                                </div>
                            </template>
                        </a-list-item>
                    </a-list>
					<a-row class="pagination">
                        <a-pagination :total="total2" :item-render="$root.itemRender"
                            @change="getTransactions(current_page2)" v-model="current_page2" />
                    </a-row>
                </a-card>
                <!-- / Your Transactions Card -->

            </a-col>
            <!-- / Your Transactions Column -->

        </a-row>

    </div>
</template>

<script>


    // Salary cards data
    const salaries = [{
            value: 0,
            prefix: "ریال ",
            icon: `
										<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22">
											<g id="bank" transform="translate(0.75 0.75)">
												<path id="Shape" transform="translate(0.707 9.543)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1.5"/>
												<path id="Path" d="M10.25,0,20.5,9.19H0Z" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1.5"/>
												<path id="Path-2" data-name="Path" d="M0,.707H20.5" transform="translate(0 19.793)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1.5"/>
											</g>
										</svg>`,
            title: "کیف پول",
            content: " موجودی نقدی ",
        },
        {
            value: 0,
            prefix: "ریال ",
            icon: `
										<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22">
											<g id="bank" transform="translate(0.75 0.75)">
												<path id="Shape" transform="translate(0.707 9.543)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1.5"/>
												<path id="Path" d="M10.25,0,20.5,9.19H0Z" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1.5"/>
												<path id="Path-2" data-name="Path" d="M0,.707H20.5" transform="translate(0 19.793)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1.5"/>
											</g>
										</svg>`,
            title: "تهاتر",
            content: " موجودی فعلی ",
        },
    ];


    export default ({
        
        data() {
            return {
                salaries,
                info: {},
                profits: [],
                total: 0,
                current_page: 1,
                sumProfits: 0,
				transactions: [],
                total2: 0,
                current_page2: 1,
				data: [],
                total3: 0,
                current_page3: 1,
            }
        },
        mounted() {
            this.getData();
            this.getProfits();
            this.getTransactions();
			this.getOrders();
        },
        methods: {
            getData() {
                let _this = this;
                axios
                    .get("/users/single/" + this.$route.params.id)
                    .then(function(response) {
                        _this.info = response.data;
                        _this.salaries[0].value = _this.info.wallet + _this.info.investment
                        _this.salaries[1].value = _this.info.barter
                    })
                    .catch(function(err) {
                        _this.$root.handleAxiosError(err);
                    });
            },
            async getProfits() {
                let _this = this;
                let url =
                    `/transactions/profits?page=${this.current_page}&&user_id=${this.$route.params.id}`;
                await axios
                    .get(url)
                    .then(function(response) {
                        _this.profits = response.data.data.data;
                        _this.total = response.data.data.total;
                        _this.current_page = response.data.data.current_page;
                        _this.sumProfits = response.data.sumProfits;
                    })
                    .catch(function(err) {
                        _this.$root.handleAxiosError(err);
                    });
            },
			async getTransactions(){
				let _this = this;
                let url =
                    `/transactions?page=${this.current_page2}&&user_id=${this.$route.params.id}`;
                await axios
                    .get(url)
                    .then(function(response) {
                        _this.transactions = response.data.data;
                        _this.total2 = response.data.total;
                        _this.current_page2 = response.data.current_page;
                    })
                    .catch(function(err) {
                        _this.$root.handleAxiosError(err);
                    });
			},
			async getOrders() {
                let _this = this;
                let url = `/orders?page=${this.current_page3}&&user_id=${this.$route.params.id}`;
                await axios
                    .get(url)
                    .then(function(response) {
                        _this.data = response.data.data;
                        _this.total3 = response.data.total;
                        _this.current_page3 = response.data.current_page;
                    })
                    .catch(function(err) {
                        _this.$root.handleAxiosError(err);
                    });
            },
        }
    })
</script>

<style lang="scss">
</style>
